import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const MultiSelectionList = (props) => {
    const { value, handleChange, options } = props;

    return (
        <Select
            isMulti
            onChange={handleChange}
            options={options}
            value={value}
        />
    );
};

MultiSelectionList.propTypes = {
    value: PropTypes.array,
    handleChange: PropTypes.func,
    options: PropTypes.array
};

export default MultiSelectionList;



// WEBPACK FOOTER //
// ./app/components/multi-selection-list/index.js